export class Error {
	public status: number;
	public statusText: string;
	public message: string;
}